import angular from 'angular';
import $ from 'jquery';

angular.module('webTools').directive('wtObjectViewer', ['Preview', '$compile', '$timeout',
    function (Preview, $compile, $timeout) {
        return {
            restrict: 'A',
            link: function (scope, element, attributes) {

                scope.currentFile = '';

                scope.$on('closePreviewOverlay', function () {
                    angular.element(document.body).find('#previewOverlay').fadeOut(function (element) { angular.element(document.body).find('#previewOverlay').remove(); });
                });

                scope.$on('loadObjectPreview', function (e, file) {
                    angular.element(document.body).append('<div id="previewOverlay" class="hidden">' +
                        '<div class="fakeHeader">' +
                        '<div class="pdfjsToolbarButton" onclick="window.angular.element(\'#container\').scope().$emit(\'closePreviewOverlay\');">X</div>' +
                        '</div>' +
                        '<img id="loading" class="preview-loading" src="/images/482.gif" />' +
                        '</div>');

                    angular.element('#previewOverlay').fadeIn('fast');

                    var promises = Preview.getPreview(file.id, file.version, file.minor);

                  promises.deferred.promise.then(function (res) {

                        if (res.isImage === true) {
                            var imageScope = scope.$new();
                            imageScope.path = res.path;
                            var el = $compile('<wt-responsive-image image-source="path" left-right-padding="100" top-bottom-padding="150"></wt-responsive-image>')(imageScope);

                            angular.element('#previewOverlay').append(el);
                            scope.$on('imagePreviewLoaded', function () { angular.element('#loading').hide(); });

                        } else {

                          angular.element('#previewOverlay').append('<iframe id="previewFrame" class="hidden" src="/lib/pdf.js/web/viewer.html?file=' + encodeURIComponent(res.path) + '"></iframe>')
                            angular.element('#loading').hide();
                            angular.element('#previewFrame').fadeIn(function () { angular.element('.fakeHeader').hide(); });

                            let loopCounter = 0;

                            const showCloseButton = () => {
                                const frameBody = $('#previewOverlay').find('iframe')[0].contentWindow.document.body;
                                const el = frameBody && frameBody.querySelector('.closeButton');

                                if (loopCounter < 250) {
                                    if (el) {
                                        el.style.display = 'block';
                                    } else {
                                        $timeout(function () {
                                            showCloseButton();
                                            loopCounter++;
                                        }, 100)
                                    }
                                }
                            }

                            showCloseButton();
                        }
                    });
                });
            }
        }
    }
]);

angular.module('webTools').service('Preview', ['$q', '$http',
    function ($q, $http) {

        return {
            getPreview: function (id, version, minor) {

                var promises = {
                    deferred: $q.defer(),
                    canceler: $q.defer()
                }

                $http.get('/api/preview/getpreview?id=' + id + '&version=' + version + '&minor=' + minor, { timeout: promises.canceler.promise })
                    .then(function (response) {
                        let data = response.data;
                        promises.deferred.resolve(data);
                    });

                return promises;
            }
        }
    }
]);